import { type IconName } from '../lt-icon/lt-icon.config';

export const Severity = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  FAMILY_DISCOUNT: 'familyDiscount'
} as const);

export type Severity = (typeof Severity)[keyof typeof Severity];

export const SEVERITY_ICON_MAP: Record<Severity, IconName> = {
  success: 'fa-sharp-regular-check-circle',
  info: 'fa-sharp-regular-info-circle',
  warning: 'fa-regular-triangle-exclamation',
  error: 'fa-sharp-regular-circle-exclamation',
  familyDiscount: 'fa-regular-badge-dollar'
};
